/**
 * Labor Component Endpoints
 */

export const apiPostLaborComponent = async (
  labelComponent: LaborComponentCreateUpdate,
): Promise<AxiosResponse<LaborComponent>> => {
  return await userManagementAxiosInstance.post('labor_components', labelComponent);
};

export const apiGetLaborComponents = async (
  limit: number = defaultLimit,
  offset: number = defaultOffset,
  search: string = '',
): Promise<AxiosResponse<PaginatedLaborComponent>> => {
  return await userManagementAxiosInstance.get(
    `labor_components?limit=${limit}&offset=${offset}&name=${search}`,
  );
};

export const apiGetLaborComponent = async (
  id: string | number,
): Promise<AxiosResponse<LaborComponent>> => {
  return await userManagementAxiosInstance.get(`labor_components/${id}`);
};

export const apiPutLaborComponent = async (
  labelComponent: LaborComponentCreateUpdate,
): Promise<AxiosResponse<LaborComponent>> => {
  return await userManagementAxiosInstance.put(
    `labor_components/${labelComponent.id}`,
    labelComponent,
  );
};

export const apiDeleteLaborComponent = async (
  id: string | number,
): Promise<AxiosResponse<LaborComponent>> => {
  return await userManagementAxiosInstance.delete(`labor_components/${id}`);
};
